<template>
  <DropDownModular
    :options="options"
    :selected="status"
    @updateSelected="$emit('updateStatus', $event)"
  >
    <template #head>
      <div
        class="project-status-icon-container"
        :style="`border-color: ${getColor()};`"
        v-ripple
      >
        <TransitionRotate v-for="(option, index) in options" :key="`project-status-display${index}`">
          <TIcon
            v-if="option.value === status"
            class="project-status-icon"
            style=""
            :name="option.icon"
            :size="20"
          />
        </TransitionRotate>
      </div>
    </template>
  </DropDownModular>
</template>
<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TransitionRotate from '@/components/WorkPackageWIP/TransitionRotate.component.vue';
import DropDownModular from '@/components/WorkPackageWIP/DropDownModular.component.vue';

export default {
  props: [
    'status',
    'can_update',
    // 'is_company_project', // TODO: check if project is company project and disable live option if this is the case
  ],

  components: {
    TIcon,
    TransitionRotate,
    DropDownModular,
  },

  mixins: [
    TColor,
  ],

  data: () => ({

  }),

  computed: {
    options() {
      let project_states = this.$store.state.Ultra.project_states;

      project_states.forEach((option) => {
        option.requires_pro = option.restricted && !this.can_update;
        option.disabled = !this.can_update;
      });

      return project_states;
    },
  },
}
</script>
<style lang="css">
.project-status-icon-container {
  width: 24px;
  height: 24px;
  border: 2px solid;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.project-status-icon {
  position: absolute;
}
.project-status-option-disclaimer {
  white-space: nowrap;
}
</style>
